import React, { useContext, useState } from "react";
import { TranslatorContext } from "../../context/Translator";
import {  Tab, Tabs, } from "react-bootstrap";
import cuotas from "../../assets/data/cuotas.json";
import cuotaspagadas from "../../assets/data/cuotaspagadas.json";
import { ButtonComponent } from "../elements";

import Modal from 'react-bootstrap/Modal';


export default function AdminPagosGiraComponent() {

    const { t } = useContext(TranslatorContext)
    const [selectedCuotas, setSelectedCuotas] = useState([]);
    const [totalMonto, setTotalMonto] = useState(0);
    const [alertModal, setAlertModal] = useState(false);

    const handleCheckboxChange = (cuota) => {
        const isSelected = selectedCuotas.includes(cuota.id);
        let newSelectedCuotas;
        let newTotalMonto;

        if (isSelected) {
            newSelectedCuotas = selectedCuotas.filter(id => id !== cuota.id);
            newTotalMonto = totalMonto - Number(cuota.monto);
        } else {
            newSelectedCuotas = [...selectedCuotas, cuota.id];
            newTotalMonto = totalMonto + Number(cuota.monto);
        }

        setSelectedCuotas(newSelectedCuotas);
        setTotalMonto(newTotalMonto);
    };
    const handlePay = () => {
        // Lógica para procesar el pago
        alert(`Pagando un total de ${totalMonto}`);
    };

    return (
        <div className="mc-card">
            <div className="mc-card-header">
                <h4 className="mc-card-title">Pagos</h4>
               
            </div>
            <Tabs defaultActiveKey="profile" id="mc" className="mc-tabs">
                <Tab eventKey="profile" title="Cuotas Viajes" className="mc-tabpane profile">
                <ul className="mc-activity-card-list thin-scrolling">
               
                <table className="mc-table">
                    <thead className="mc-table-head primary">
                        <tr>
                        <th ></th>   
                         <th >Nº Cuota</th>
                         <th >Fecha vencimiento</th>
                         <th >Monto</th>
                         <th >Estado</th>
                        
                        </tr>
                    </thead>
                    <tbody className="mc-table-body even">
                        {cuotas.tbody?.map((item, index) => (
                            <tr key={ index }> 
                            <td title="id">
                               <input type="checkbox" 
                                checked={selectedCuotas.includes(item.id)}
                                onChange={() => handleCheckboxChange(item)}/>
                                </td>
                                <td title="id">
                                { item.id }
                                </td>
                                <td title={ item.created }>
                                { item.created }
                                </td>
                                <td title={ item.monto }>
                                { item.monto}
                                </td>
                                <td title={ item.name }>
                                { item.estado}
                                </td>
                               
                            </tr>
                        ))}
                    </tbody>
                 </table>
    
               
                    
                    </ul>
                    <div className="total-monto">
                        <h5>Total a Pagar: {totalMonto}</h5>
                    </div>
                   
                    <ButtonComponent onClick={()=> setAlertModal(true)} className="btn btn-secondary">Pagar</ButtonComponent>
                  
                </Tab>
                <Tab eventKey="password" title="Historial Pagos" className="mc-tabpane password">
                <ul className="mc-activity-card-list thin-scrolling">
              
                    <table className="mc-table">
                    <thead className="mc-table-head primary">
                        <tr>
                        
                         
                         <th >Fecha pago</th>
                         
                         <th >Metodo pago</th>
                         <th >Comprobante</th>
                        </tr>
                    </thead>
                    <tbody className="mc-table-body even">
                        {cuotaspagadas.tbody?.map((item, index) => (
                            <tr key={ index }> 
                            
                              
                                <td title={ item.created }>
                                { item.created }
                                </td>
                             
                                <td title={ item.metodo }>{ item.metodo }</td>
                               
                                
                                <td>
                                    <div className="mc-table-action">
                                        
                                        <ButtonComponent title="Block" className="material-icons download">{ item.action.block }</ButtonComponent>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                 </table>
    
                
                    </ul>
                </Tab>    
            </Tabs>   

            <Modal show={ alertModal } onHide={()=> setAlertModal(false)}>
                <div className="mc-alert-modal">
                    <i className="material-icons">new_releases</i>
                    <h3>¿Esta seguro/a de registrar el pago?</h3>
                    <p>El pago se esta realizando en forma presencial</p>
                    <Modal.Footer>
                        <ButtonComponent type="button" className="btn btn-secondary" onClick={()=> setAlertModal(false)}>Cancelar</ButtonComponent>
                        <ButtonComponent type="button" className="btn btn-danger" onClick={()=> setAlertModal(false)}>Aceptar</ButtonComponent>
                    </Modal.Footer>
                </div>
            </Modal>

           
        </div>
    )
}